import { connect, MapStateToProps } from 'react-redux';
import { Props } from './NCNotification';
import { getMessageState } from '../../redux/selectors/messageStates';

type StateProps = Pick<Props, 'isLoading'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (state, props) => ({
  isLoading: getMessageState(state, props.notification.messageId).isLoading,
});

export default connect(mapStateToProps);
